import { render, staticRenderFns } from "./PortfolioProjects.vue?vue&type=template&id=4c2d83b8"
import script from "./PortfolioProjects.vue?vue&type=script&lang=ts"
export * from "./PortfolioProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports